export default function FavoriteCodes() {
  return <div>Favorite Codes</div>;
}
